import { createFileRoute } from '@tanstack/react-router';
import { UserRole } from '@ata-digital/client-tax-system-api-client';
import { UserAdminPage } from '@/features/preparer/users/UserAdminPage';
import { usersSearchSchema } from '@/schemas/user.schema';
import { userSettingQueryOptions } from '@/lib/query/options';

// Extend the base schema to set defaults for this route
const usersRouteSearchSchema = usersSearchSchema.extend({
  role: usersSearchSchema.shape.role.default(UserRole.Client),
  isActive: usersSearchSchema.shape.isActive.default(true),
});

export const Route = createFileRoute('/preparer/users/')({
  loader: async ({ context: { queryClient } }) => {
    const authState = queryClient.getQueryData(['auth', 'session']) as
      | { token?: string; isAuthenticated?: boolean }
      | undefined;

    if (authState?.token) {
      queryClient.prefetchQuery(userSettingQueryOptions.current(authState.token)).catch(() => {});
    }
  },
  component: UserAdminPage,
  validateSearch: usersRouteSearchSchema,
});
